export default {
    pageBackground: '#EEEEEE',
    blue: '#1ADEF7',
    blueRGB: '26,222,247',
    blueDk: '#1540D0', // used for links; meets 4.5:1 contrast on Colors.blue
    red: '#FF124F',
    redRGB: '255,18,79',
    grey: '#2f302f',
    black: '#000000',
    white: '#FFFFFF',
    yellow: '#F2CC17',
    yellowRGB: '242,204,23',
};
